export const PARTNERS_INITIATE = '[PARTNERS] INITIATE';

export const GET_PARTNERS = '[PARTNERS] GET PARTNERS';
export const GET_ACTIVITIES = '[PARTNERS] GET ACTIVITIES';

export const CHANGE_SINGLE_PARTNER = '[PARTNERS] CHANGE SINGLE PARTNER';
export const RECEIVE_GHOST_PARTNER_DATA = '[PARTNERS] RECEIVE GHOST PARTNER DATA';
export const HIDE_GHOST_PARTNER = '[PARTNERS] HIDE GHOST PARTNER';
